import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { DeliveryZoneDecisionResponse } from "@/custom-types/Compliance";
import { HYDRATE } from "@/redux/reducers/hydration";

export type DispensaryState = {
  deliveryZone?: DeliveryZoneDecisionResponse | null;
  followed: boolean;
};

export const initialState: DispensaryState = {
  deliveryZone: null,
  followed: false,
};

const dispensarySlice = createSlice({
  extraReducers: (builder) => {
    /**
     * Ignore any hydration events after initial page load to preserve any
     * subsequent changes that have been made on the client.
     */
    builder.addCase(HYDRATE, () => {});
  },
  initialState,
  name: "dispensary",
  reducers: {
    follow: (state) => {
      state.followed = true;
    },
    setDeliveryZone: (
      state,
      action: PayloadAction<DeliveryZoneDecisionResponse | null>,
    ) => {
      state.deliveryZone = action.payload;
    },
    unfollow: (state) => {
      state.followed = false;
    },
  },
});

export const { setDeliveryZone, follow, unfollow } = dispensarySlice.actions;
export default dispensarySlice.reducer;
